<a href="{{ data.url }}" class="news-item__inner" [title]="data.title" *ngIf="data.url">
    <div class="news-item__media">
        <wuc-picture
            *ngIf="data.images?.xs?.uri"
            [imageDesktop]="imageWebpData"
            [imageWidth]="{ desktop: data.images?.xs?.width }"
            [imageHeight]="{ desktop: data.images?.xs?.height }"
            imageType="image/webp"
            [alt]="data.title"
        ></wuc-picture>
    </div>
    <div class="news-item__content" *ngIf="data.title">
        <h3>{{ data.title }}</h3>
        <div class="news-item__text">
            <p>{{ data.excerpt }}</p>
        </div>
        <span *ngIf="data.leesmeer" class="link-secondary link-secondary--more">
            <svg class="svg-icon svg-icon--xs"><use href="assets/icons-ui.svg#rechts-open"></use></svg>
            {{ data.leesmeer }}
        </span>
    </div>
</a>

<div class="news-item__inner" *ngIf="!data.url">
    <div class="news-item__media">
        <wuc-picture
            *ngIf="data.images?.xs?.uri"
            [imageDesktop]="imageWebpData"
            [imageWidth]="{ desktop: data.images?.xs?.width }"
            [imageHeight]="{ desktop: data.images?.xs?.height }"
            imageType="image/webp"
            [alt]="data.title"
        ></wuc-picture>
    </div>
    <div class="news-item__content" *ngIf="data.title">
        <h3>{{ data.title }}</h3>
        <div class="news-item__text">
            <p>{{ data.excerpt }}</p>
        </div>
        <span *ngIf="data.leesmeer" class="link-secondary link-secondary--more">
            <svg class="svg-icon svg-icon--xs"><use href="assets/icons-ui.svg#rechts-open"></use></svg>
            {{ data.leesmeer }}
        </span>
    </div>
</div>
